/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import _ from 'lodash';
import * as ActionTypes from './ActionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING,
  isLoading: value,
});

export const setSearchInput = (data) => ({
  type: ActionTypes.SET_SELECTED_INPUT,
  payload: data,
});

export const refreshFamilyPlanningDrugPmtRecDisplay = () => ({
  type: ActionTypes.REFRESH_FAMILY_PLANNING_DRUG_PMT_REC_DISPLAY,
  payload: {},
});
export const refreshFamilyPlanningDrugPmtRec = () => ({
  type: ActionTypes.REFRESH_FAMILY_PLANNING_DRUG_PMT_REC,
  payload: {},
});

export const getPlanTypeValues = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchPlanType([]));
    });
};

//API to get Reabte Program List
export const getRebateProgrameList = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      dispatch(setLoading(false));
      return response.data.data;
    })
    .catch((response) => {
      dispatch(setLoading(false));
    });
};

//dispatchAPI
export const dispatchFamilyPlanningDrugPmtRecData = (data) => ({
  type: ActionTypes.SET_FAMILY_PLANNING_DRUG_PMT_REC_DATA,
  payload: data,
});

// This action show error message for 5 sec for no contract exists
const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  // dispatch(setSearchInput({ errors: [] }));
  // }, 5000);
  dispatch(
    setSearchInput({
      errors: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};
//get  list
export const getFamilyPlanningDrugPmtRecData = (values) => (dispatch) => {
  dispatch(setLoading(true));
  dispatch(dispatchFamilyPlanningDrugPmtRecData([]));
  return axios
    .post(serviceEndPoint.GET_FAMILY_PLANNING_DRUG_PMT_REC_DATA, values)
    .then((response) => {
      dispatch(setLoading(false));
      if (
        response?.data?.familyPlanningDrugPaymentReceivedReportGridVO.length ===
        0
      ) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(
          dispatchFamilyPlanningDrugPmtRecData(
            response?.data?.familyPlanningDrugPaymentReceivedReportGridVO
          )
        );
      }
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchFamilyPlanningDrugPmtRecData([]));
    });
};
